import type { Locale } from './context'

export function translationUrl(locale: Locale): string {
  return `/lang/${locale}.ftl?v=${encodeURIComponent(__BUILD_TIMESTAMP__)}`
}
